import { getDevicePixelRatio } from "@tradingApp/utils/getDevicePixelRatio";

export function mergeCanvasLayers(
  sourceCanvas: HTMLCanvasElement,
  destinationCanvas: HTMLCanvasElement,
): void {
  const isSourceCanvasValid = sourceCanvas instanceof HTMLCanvasElement;

  const isDestinationCanvasValid =
    destinationCanvas instanceof HTMLCanvasElement;

  if (!isSourceCanvasValid || !isDestinationCanvasValid) {
    return;
  }

  const devicePixelRatio = getDevicePixelRatio();
  const destinationContext = destinationCanvas.getContext("2d");

  if (destinationContext === null) {
    return;
  }

  const { width: sourceCanvasWidth, height: sourceCanvasHeight } = sourceCanvas;

  const { width: destinationCanvasWidth, height: destinationCanvasHeight } =
    destinationCanvas;

  const allSizes = [
    sourceCanvasWidth,
    sourceCanvasHeight,
    destinationCanvasWidth,
    destinationCanvasHeight,
  ];

  const isValidSizes = allSizes.every(
    (size) => Number.isFinite(size) && size > 0,
  );

  if (isValidSizes) {
    destinationContext.drawImage(
      sourceCanvas,
      0,
      0,
      sourceCanvasWidth,
      sourceCanvasHeight,
      0,
      0,
      destinationCanvasWidth / devicePixelRatio,
      destinationCanvasHeight / devicePixelRatio,
    );
  }
}
